import * as React from 'react';
import { cn } from '../../lib/cn';

// Shimmer placeholder. Use width/height via className (e.g. h-4 w-1/2).
export function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return <div className={cn('animate-pulse rounded-md bg-muted', className)} {...props} />;
}
